import React from "react";


export default function Footer() {
  const handleScroll = (href) => {
    if (href.startsWith('#')) {
      const isHome = window.location.pathname === '/home';
      if (isHome) {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = '/home' + href;
      }
    } else {
      window.location.href = href;
    }
  };

  return (
    <footer className="border-t border-border/50 bg-muted/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img 
              src="https://media.base44.com/images/public/69d14ed5d129627680ef5d0f/f192ef588_cropped-Copy-of-host1help1-email-22.png" 
              alt="Host1Help1" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Hassle-free managed web hosting so you can focus on what matters — your business.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Home", href: "#hero" },
                { label: "Features", href: "#features" },
                { label: "Hosting", href: "#hosting" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleScroll(link.href)}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Testimonials", href: "#testimonials" },
                { label: "Non-Profits", href: "/non-profits" },
                { label: "Pay Invoice", href: "/invoice-payment" },
                { label: "Privacy Policy", href: "/privacy-policy" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleScroll(link.href)}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="tel:360.389.2897"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  360.389.2897
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@host1help1.com"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  support@host1help1.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Host1Help1. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Hosted and Designed by <a href="https://www.host1help1.com" className="hover:text-primary transition-colors">Host1Help1.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}